import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-[1400px] mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 bg-[#39FF14] rounded-lg flex items-center justify-center">
              <i className="ri-brain-line text-xl text-black"></i>
            </div>
            <span className={`font-bold text-lg transition-colors ${
              scrolled ? 'text-black' : 'text-white'
            }`}>
              Entrenamiento Inteligente
            </span>
          </Link>

          <div className="flex items-center gap-6">
            <Link 
              to="/" 
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#39FF14]' : 'text-white hover:text-[#39FF14]'
              }`}
            >
              Inicio
            </Link>
            <Link 
              to="/" 
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#39FF14]' : 'text-white hover:text-[#39FF14]'
              }`}
            >
              Módulos
            </Link>
            <Link 
              to="/" 
              className="px-6 py-2.5 bg-[#39FF14] text-black font-medium rounded-lg hover:bg-[#2DE00F] transition-all whitespace-nowrap cursor-pointer"
            >
              Inscríbete
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}